import {Box, Dialog, useTheme} from "@mui/material";

import {dataGridRowBorder} from "../../../../theme";
import {DialogHeading} from "../../AddAndUpdateSaas/dialogs/misc/styles";
import {ICompany} from "../../../../types/Company";
import {ClientNotificationSettings} from "../NotificationPanel/ClientNotificationSettings";

// Lets a super admin manage the notification settings of any client
export const ClientNotificationSettingsDialog = ({
  client,
  userRole,
  onClose,
}: {
  client: ICompany,
  userRole: string,
  onClose: () => void,
}) => {
  const theme = useTheme();

  return (
    <Dialog open={true} onClose={onClose} maxWidth={false}>
      <Box
        sx={{
          border: dataGridRowBorder,
          borderRadius: theme.more.borderRadius,
          padding: theme.spacing(2),
          width: '1000px',
        }}
      >
        <DialogHeading>Notifications for {client.name}</DialogHeading>
        <ClientNotificationSettings
          clientId={client.id}
          userRole={userRole}
          canEdit={true}
          onSaved={onClose}
          onCancel={onClose}
        />
      </Box>
    </Dialog>
  );
};
